import { Location, NavigateFunction } from 'react-router'
import { warning } from './warning'

/**
 * Navigates to the current page while optionally replacing the history entry and refreshing data.
 *
 * @param navigate - The navigation function used to change the current route.
 * @param location - The current location object containing the pathname and search parameters.
 * @param replace - Optional. Whether to replace the current history entry. Defaults to `true`.
 * @param refreshData - Optional. Whether to include a state indicating that data should be refreshed, in withAsyncData HOC and ListV2. Defaults to `true`.
 */
const navigateToCurrentPage = (navigate: NavigateFunction, location: Location, replace: boolean = true, refreshData: boolean = true) => {
  warning(location, 'location is not defined!')
  warning(navigate, 'navigate is not defined!')

  navigate(location.pathname + location.search, { replace, state: refreshData ? { refreshData: new Date().getTime() } : undefined })
}

export default navigateToCurrentPage
